import { useSelector } from 'react-redux';
import { MAX_INSURED_VALUE } from '@shipstation/client-common/constants/insurance';

import Global from '../../store/global-selectors';
import { InsuranceProviders } from '../../enums/insurance-providers';
import { USD } from '../../constants/currency-codes';
import { useAvailableInsuranceOptions } from '../../services/insurance-service';

const highValueThresholds = {
  USD: 150,
  AUD: 220,
  GBP: 120,
};

export const signatureMayBeRequiredAmount = 499;

export const maxInsuredValue = MAX_INSURED_VALUE;

export const isHighValueOrder = (currencyCode, itemCost) => {
  return itemCost > highValueThresholds[currencyCode] || false;
};

export const useGetInsuranceAlerts = (calculateRecommendedInsuranceValue, insuranceProvider, hasInsuranceProviderSelected) => {
  const sellerCurrencyCode = useSelector(Global.selectSellerDefaultCurrency) || USD;
  const insuranceOptions = useAvailableInsuranceOptions();
  const insuredAmount = calculateRecommendedInsuranceValue();

  const showHighValueWarning = !hasInsuranceProviderSelected && isHighValueOrder(sellerCurrencyCode, insuredAmount);
  const maximumCoverageWarning = insuredAmount > maxInsuredValue;
  const selectedInsuranceOptionId = insuranceProvider.insuranceProviderId;
  const isMaxCoverageExceeded =
    maximumCoverageWarning &&
    (selectedInsuranceOptionId === InsuranceProviders.ParcelGuard.insuranceProviderId ||
      selectedInsuranceOptionId === InsuranceProviders.XCover.insuranceProviderId);
  const signatureMayBeRequiredWarning = insuredAmount > signatureMayBeRequiredAmount && sellerCurrencyCode === USD;
  const hasUnknownInsuranceProvider = !insuranceOptions.find((option) => option.name === insuranceProvider.name);

  return {
    insuredAmount,
    selectedInsuranceOptionId,
    showHighValueWarning,
    isMaxCoverageExceeded,
    signatureMayBeRequiredWarning,
    hasUnknownInsuranceProvider,
  };
};
